import Actions from '../../odata/actions';

const actions = new Actions('reportDefinition', 'reportDefinitions');

export default actions;
